"use client"

import { useState } from "react"

import { BannerCarousel } from "@/components/reusebale-components/bannerCarousel";
import SocialCard from "@/components/social/SocialCard";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import HeaderTitle from "@/components/reusebale-components/HeaderTitle";
import { Separator } from "@/components/ui/separator";
import { CallToAction } from "@/components/reusebale-components/CallToAction";
import { useFetchSWR } from '@/lib/swrConfig';
import { bannerEnum as be } from '@/lib/utils';
import endPoints  from '@/lib/apiEndPoints'
import { Spinner } from "@/components/ui/spinner";
import { CommitmentData } from "@/types/commitments";

import { useFetchSWRInfinite } from '@/lib/swrConfig';

import { BannerData } from "@/types/banner";

const  QUERY_LIMIT = 4;
export default function page() {
    // banner data
    const { data: bannerData , isLoading } = useFetchSWR(endPoints.BANNER(be.COMMITMENT));
    const banner: BannerData = bannerData?.status === 200 ? bannerData.data : {};

     // social commitment data fetch
    const getKey = (pageIndex: number, previousPageData: any) => {
    if (previousPageData && !previousPageData.data.length) return null;
        return endPoints.COMMITMENTS(pageIndex + 1,QUERY_LIMIT );
    };

    const { data, size, setSize, isValidating } = useFetchSWRInfinite(getKey);

    const commitments = data ? data.flatMap((page) => page.data) : [];
    const isReachingEnd = data && data[data.length - 1]?.data.length < QUERY_LIMIT;

    const [visibleCount, setVisibleCount] = useState(4)
    const handleViewMore = () => {
        setVisibleCount((prev) => prev + 4)
    }
    return (
        <main>
            {/* Banner */}
            {
                      isLoading ? (
                          <div className="h-screen flex items-center justify-center">
                          <Spinner />
                          </div>
                      ) : (
                          <BannerCarousel
                          images={banner?.media?.map((media) => media.url)}
                          title={banner?.title}
                          description={banner?.details}
                          />
                      )
                  }

            { commitments.length > 0 && (
                <div className="container mt-6 md:mt-10 lg:mt-16">
                { commitments?.length > 0 && (
                    <HeaderTitle title="Corporate Social Responsibility" url="" />
                )}
                <div className="space-y-4 md:space-y-8 ">
                    {commitments.slice(0, visibleCount).map((item:CommitmentData) => (
                        <div key={item.id}>
                            <SocialCard {...item} />
                        </div>
                    ))}
                </div>
                {/* --- See More Button --- */}
                    {!isReachingEnd  && (
                        <div className="mt-8 flex items-center justify-center">
                            <Button
                                onClick={() => setSize(size + 1)}
                                disabled={isValidating}
                                className="flex items-center bg-primary text-white rounded-full px-8 py-3 cursor-pointer hover:bg-prime-hover transition-colors"
                                size="lg"
                            >
                                {isValidating ? <Spinner /> : `See More`}
                                <ChevronDown size={16} className="ml-1" />
                            </Button>
                        </div>
                    )}
            </div>
            )}

            <div className="container">
            <Separator className="my-6 md:my-10 lg:my-16 " />
            </div>

            <div className="container mb-6 md:mb-10 lg:mb-16">
                <CallToAction
                    title="Join Us in Making a Difference"
                    description="Your support can create lasting change in our communities. Get involved and make an impact today!"
                    buttonText="Contact" />
            </div>
        </main>
    )
}